module.exports = __webpack_public_path__ + "img/laptop-slash.263810cf.svg";